import { render, staticRenderFns } from "./SeasonPage.vue?vue&type=template&id=c564f9ee&"
import script from "./SeasonPage.vue?vue&type=script&lang=js&"
export * from "./SeasonPage.vue?vue&type=script&lang=js&"
import style0 from "./SeasonPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports